<a [href]="getFixtureLink(race)" (click)="track(race)">
    <div class="race-name">
        <div class="race-details">
            <div class="race-name-time">
                <span> {{ race.meeting.name | msTranslate }}</span>
                <span>{{ race.startDate | date: 'HH:mm' }}</span>
            </div>
            <ms-promotion-badge *ngIf="promotedFixtureIdsMap[race.id]" />
            <ms-race-view-best-odds-badge class="race-badge" [fixture]="race" />
        </div>
        <div class="race-details">
            <ms-next-races-title-preview msTextAutoScroll class="race-title" [fixture]="race" />
            <ms-race-time-status [isSports]="true" [race]="race" [timeInSeconds]="timeInSeconds" [status]="updateStatus(race)" />
        </div>
    </div>
</a>
<ms-race-preview *ngIf="!race.isOptionBet" [race]="race" [trackingPosition]="trackingPosition" />
<ms-derived-race-preview *ngIf="race.isOptionBet" [race]="race" [trackingPosition]="trackingPosition" />
<a [href]="getFixtureLink(race)" (click)="track(race, viewFullRace)">
    <div class="race-view-full ms-active-highlight">
        <span class="race-name-name">{{ viewFullRace }} ({{ participantsLength }} {{ sitecore.horseRacing.nextThreeRaces!.Runners }})</span>
    </div>
</a>
